import { HTMLLoginFormElement } from "./custom-elements/html-login-form-element"
import { env } from "./lib/env"
import { getElement } from "./lib/get-elements"

const loginForm = getElement("#login-form", document, HTMLLoginFormElement)

loginForm.addEventListener("login", () => {
	const queryString = new URLSearchParams(window.location.search)
	const redirectUrl = queryString.get("redirect")
	window.location.href = redirectUrl ?? "/"
})

loginForm.apiSrc = env.logApiUrl
